import React from 'react';
import PageLayout from '../../components/PageLayout';

import PaymentDetails from './PaymentDetails';
import './style.css';

export default function Payments() {
  return <PageLayout details={<PaymentDetails />} />;
}
